module.exports = __webpack_public_path__ + "media/mediaProfessionals/block-image-3-52ab4773.png";